module.exports = __webpack_public_path__ + "img/preprocessing-data.6adb6eab.gif";